import { render, staticRenderFns } from "./DatasetSearch.vue?vue&type=template&id=99cab506&scoped=true"
import script from "./DatasetSearch.vue?vue&type=script&lang=ts"
export * from "./DatasetSearch.vue?vue&type=script&lang=ts"
import style0 from "./DatasetSearch.vue?vue&type=style&index=0&id=99cab506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cab506",
  null
  
)

export default component.exports